import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { getVideoSubscription, checkIfEmailExists, getAndroidSubscriptionDetails, getUpcomingInvoice, subscriptionUpdate, getPlanDetails } from "../../Subscription/service";
import { getUserSubscription } from "../../../network/service"
import { registerUser } from '../Register/service';
import { googleLogin, login, updateLoginWithoutCode } from '../Login/service';
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import { analytics2, authenticate } from "../../../network/service";
import { getUser } from "../../../Redux/UserSlice/UserSlice";
import { getLanguageModal } from '../../../Redux/LanguageModal/languageModalSlice';
import { getAccessToken } from "../../../Redux/AToken/ATokenSlice";
import { getUserDetails } from "../../../Redux/UserDetailsSlice/UserDetailsSlice";
import { getUserSubscriptionData } from "../../../Redux/UserSubscriptionDetails/userSubscriptionSlice";
import LoginModal from "../../../Components/Modals/LoginModal/LoginModal";
import { stripeSession, applyCouponCode, cinetPayApiSession, squareSubscription, bogSubscription } from "../../Subscription/service";
import Translate from "../../../Components/Multilanguage/Translate";
import { useTranslateText } from "../../../Components/Multilanguage/Translate";
import './scss/checkout.css'
import { stripHtml } from "../../../utils/utils";
import { loadStripe } from '@stripe/stripe-js';
import { set } from "firebase/database";
import PlanDetails from "./PlanDetails";
import PhoneInput from 'react-phone-input-2';
import { updateAccountdetails } from '../AccountSettings/service'
import { useGoogleLogin } from "@react-oauth/google";
import { ReactComponent as GoogleIcon } from "../../../assets/Icons/googleIcon.svg";
import SocialAccountLoginModal from "../../../Components/Modals/SocialAccountLoginModal";
import OtpModal from "../../../Components/Modals/OtpModal";
import { PayPalScriptProvider, } from "@paypal/react-paypal-js";
import PaypalButtonWrapper from "../../Subscription/PaypalButtonWrapper";
import { jwtDecode } from "jwt-decode";
import ApplePrivateLoginModal from '../../../Components/Modals/LoginModal/ApplePrivateLoginModal'
import checkoutBg from "../../../assets/Images/checkout_bg.jpg";
const Checkout = () => {

    const translateText = useTranslateText();
    const location = useLocation();
    const navigate = useNavigate();
    const projectInfo = useSelector((state) => state?.projectInfo?.value);
    const accessToken = useSelector((state) => state?.accessToken?.value);
    const dispatch = useDispatch();
    const user = useSelector((state) => state?.user?.value);
    const userData = useSelector((state) => state?.userDetails?.value);
    const userSubscriptionData = useSelector((state) => state?.userSubscription?.value);
    const isRTL = useSelector((state) => state?.rtl?.isRTL);
    const paypalRef = useRef(null);
    const subscriptionListingRef = useRef(null);
    const isSubmittingRef = useRef(false);
    const template = projectInfo?.projectConfig?.config?.TEMPLATE;
    const theme = projectInfo?.projectConfig?.config?.THEME;
    const appInfo = {
        projectDetails: projectInfo,
        accessToken: accessToken,
    };
    const videoId = location?.state?.videoId;
    const showId = location?.state?.showId;
    const channelId = location?.state?.channelId;
    const subscriptionId = location?.state?.subscriptionId;
    const subscriptionPrice = location?.state?.subscriptionPrice;
    const tvCode = location?.state?.code;
    const activeLogin = location?.state?.activeLogin;
    const urlParams = new URLSearchParams(window.location.search);
    const androidToken = urlParams.get("antkn");
    const videoIdAndroid = urlParams.get("vd");
    const eventIdAndroid = urlParams.get("ed");
    const channelIdAndroid = urlParams.get("cn");
    const videoVanity = urlParams.get("video");
    const showVanity = urlParams.get("show");
    const gateways = projectInfo?.projectConfig?.config?.WEBSITE_PAYMENT_GATEWAYS;

    const [subscriptions, setSubscriptions] = useState([]);
    const [activeSubscriptions, setActiveSubscriptions] = useState([]);
    const [hasExistingSubscription, setHasExistingSubscription] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedPlan, setSelectedPlan] = useState();
    const [selectedPlanPrice, setSelectedPlanPrice] = useState();
    const [activeDetailsPlan, setActiveDetailsPlan] = useState([]);
    const [showPassword, setShowPassword] = useState(false);
    const [activeScreen, setActiveScreen] = useState('register');
    const [isOkToProceed, setIsOkToProceed] = useState();
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [userResponse, setUserResponse] = useState()
    const [error, setError] = useState({});
    const [showAlreadyExistMessage, setShowAlreadyExistMessage] = useState(false);
    const [maskedPassword, setMaskedPassword] = useState();
    const [isFocused, setIsFocused] = useState(false);
    const [resetPasswordMessage, setResetPasswordMessage] = useState();
    const [emailLoginModal, setEmailLoginModal] = useState(false);
    const [isVizio, setIsVizio] = useState(false);
    const [otpModal, setOtpModal] = useState(false);
    const [userRegisterId, setUserRegisterId] = useState();
    const [checkoutValues, setCheckoutValues] = useState({});

    const [haveCoupon, setHaveCoupon] = useState(false);
    const [couponCode, setCouponCode] = useState();
    const [urlCode, setUrlCode] = useState(false);
    const [couponSuccess, setCouponSuccess] = useState(false)
    const [couponProcessing, setCouponProcessing] = useState(false)
    const [invoiceDetails, setInvoiceDetails] = useState("")
    const [showConfirmWindow, setShowConfirmWindow] = useState(false);
    const [stripeDeatils, setStripeDeatils] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [showFailModal, setShowFailModal] = useState(false);
    const [showSucessModal, setShowSucessModal] = useState(false);
    const [showProcessing, setShowProcessing] = useState(false);
    const [planDetails, setPlanDetails] = useState(null);
    const [planSelected, setPlanSelected] = useState(null);
    const [stripeResponse, setStripeResponse] = useState(null);
    const [showContinueButton, setShowContinueButton] = useState(true);
    const [subscriptionContinue, setSubscriptionContinue] = useState(false);
    const [showPhoneInput, setShowPhoneInput] = useState(false);
    const [changedValue, setChangedValue] = useState({});
    const [isFree, setIsFree] = useState(location?.state?.isFree);
    const [planSubId, setPlanSubId] = useState(null);
    const [userSubId, setUserSubId] = useState(null);
    const [showMembershipDetails, setShowMembershipDetails] = useState(false);
    const [registrationMessage, setRegistrationMessage] = useState(false);
    const [googleUser, setGoogleUser] = useState();
    const [showSocialLoginModal, setShowSocialLoginModal] = useState(false);
    const [socialLoginModalType, setSocialLoginModalType] = useState({});
    const [redirectUrl, setRedirectUrl] = useState("");
    const [locationState, setLocationState] = useState();
    const [showPaypalContainer, setShowPaypalContainer] = useState(false);
    const [paymentGateways, setPaymentGateways] = useState({
        cinetPay: false,
        stripe: false,
        paypal: false,
        ideabiz: false,
        square: false,
        bog: false,
    });
    const [subscriptionMethodDiv, setSubscriptionMethodDiv] = useState(false);
    const [showPaypal, setShowPaypal] = useState(false);
    const [selectedSubscriptionData, setSelectedSubscriptionData] = useState({});
    const [applePrivateData, setApplePrivateData] = useState();
    const [applePrivateLogin, setApplePrivateLogin] = useState(false);
    const [applePrivateEmail, setApplePrivateEmail] = useState();
    const [androidLoginSuccess, setAndroidLoginSuccess] = useState(false);



    const queryParams = new URLSearchParams(window.location.search);
    const pathSegments = location?.pathname.split('/');
    const checkoutSubId = location?.pathname.split('/checkout/')[1];
    useEffect(() => {
        if (checkoutSubId) {
            setIsFree(false);
            setSelectedPlan(0);
        }
    }, [checkoutSubId]);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (subscriptionMethodDiv) {
                if (subscriptionListingRef.current &&
                    !subscriptionListingRef.current.contains(event.target)) {
                    setSubscriptionMethodDiv(false);
                    setShowContinueButton(true);
                }
            }
        };

        if (subscriptionMethodDiv) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [subscriptionMethodDiv]);

    useEffect(() => {
        if (applePrivateEmail) {
            const appleData = {
                ...applePrivateData,
                ['email']: applePrivateEmail
            }
            appleLoginWithGizmott(appleData)
        }
    }, [applePrivateEmail])

    useEffect(() => {
        if (projectInfo?.projectConfig?.config?.APPLE_LOGIN_REQUIRED == "true" && projectInfo?.projectConfig?.config?.APPLE_CLIENT_ID) {
            const script = document.createElement('script');
            script.src = 'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js';
            script.async = true;
            document.body.appendChild(script);

            script.onload = () => {
                if (window.AppleID) {
                    window.AppleID.auth.init({
                        clientId: projectInfo?.projectConfig?.config?.APPLE_CLIENT_ID,
                        scope: 'email name',
                        redirectURI: projectInfo?.projectConfig?.config?.APPLE_LOGIN_REDIRECT_URL,
                        usePopup: true,
                    });

                    document.addEventListener('AppleIDSignInOnSuccess', (event) => {
                        const appleData = jwtDecode(event?.detail?.authorization?.id_token);

                        if (appleData?.sub) {
                            if (appleData?.is_private_email == "true" && appleData?.sub) {
                                setApplePrivateData(appleData)
                                setApplePrivateLogin(true)
                            } else {
                                appleLoginWithGizmott(appleData)
                            }
                        } else {
                            toast.error(<Translate textKey={'try_again_msg'} />)
                        }
                    });

                    document.addEventListener('AppleIDSignInOnFailure', (event) => {
                        console.error('Apple Sign-in failed:', event.detail.error);
                    });
                } else {
                    console.error('AppleID is not defined.');
                }
            };
            return () => {
                document.body.removeChild(script);
            };
        }

    }, []);


    const [selectedPlanDetailsKey, setSelectedPlanDetailsKey] = useState(null);

    const appleLoginWithGizmott = (data) => {
        const { email, sub } = data
        const name = email?.split('@')[0];
        const appleUserDetails = {
            appleId: sub,
            loginType: "apple",
            firstName: name,
            email,
        };
        loginWithoutCode(appleUserDetails);
    }
    const handlePlanClick = (item) => {
        const key = item?.vanity_url || item?.subscription_id;
        setSelectedPlanDetailsKey(key);
        navigate(`/checkout/${key}`);
    };

    const handleBackFromPlanDetails = () => {
        setSelectedPlanDetailsKey(null);
        navigate("/checkout");
    };
    const flag = true;

    const executeBackNavigation = () => {
        const isGoAdFree = location?.state?.is_go_ad_free || sessionStorage.getItem("checkout_is_go_ad_free") === "true";
        const savedPrev = sessionStorage.getItem("checkout_prevPath") || sessionStorage.getItem("lastDetailPath");
        const prevPath = location?.state?.prevPath || location?.state?.backURL || savedPrev;
        sessionStorage.removeItem("checkout_prevPath");
        sessionStorage.removeItem("checkout_is_go_ad_free");

        const isPlayerPath = prevPath?.includes("/video") || prevPath?.includes("/player") || prevPath?.includes("/live") || prevPath?.includes("/live-channels") || prevPath?.includes("/livestream");
        const allowPath = isGoAdFree || !isPlayerPath;

        const target = (prevPath && allowPath && prevPath !== window.location.pathname)
            ? prevPath
            : "/home";

        try {
            navigate(target, { replace: true });
            setTimeout(() => {
                if (window.location.pathname.includes("/checkout")) {
                    window.location.replace(target);
                }
            }, 50);
        } catch (e) {
            window.location.replace(target);
        }
    };

    useEffect(() => {
        const currentPrev = location?.state?.prevPath || location?.state?.backURL;
        if (currentPrev) {
            sessionStorage.setItem("checkout_prevPath", currentPrev);
        }
        if (location?.state?.is_go_ad_free) {
            sessionStorage.setItem("checkout_is_go_ad_free", "true");
        }
        const fromState = location?.state?.from;
        if (fromState) {
            sessionStorage.setItem("checkout_from", fromState);
        }

        const handleBack = () => {
            executeBackNavigation();
        };
        window.addEventListener("popstate", handleBack);
        return () => {
            window.removeEventListener("popstate", handleBack);
        };
    }, [location?.state, navigate]);

    useEffect(() => {
        const subscribedSuccess = location?.state?.subscribedSuccess;
        const prevPath = location?.state?.prevPath;
        const returnedVideoId = location?.state?.videoId;
        if (subscribedSuccess && prevPath) {
            navigate(prevPath, { state: { episodeId: returnedVideoId } });
        }
    }, [location?.state, navigate]);

    useEffect(() => {
        if (pathSegments.length === 2 && pathSegments[1] === 'checkout') {
            setSelectedPlanDetailsKey(null);
        }
        if (pathSegments.length > 2 && pathSegments[1] === 'checkout') {
            const planIdFromUrl = pathSegments[2];
            const fetchPlanDetails = async () => {
                const response = await getPlanDetails(appInfo, planIdFromUrl);
                setPlanSubId(response?.data?.data[0]?.subscription_id);
                if (response?.status === 200) {
                    const plan = response?.data?.data[0];
                    if (response?.data?.data.length === 0) {
                        setIsFree(true);
                        setSelectedPlan(0);
                    }
                    setPlanSelected(response?.data?.data[0]);
                    setSelectedPlanDetailsKey(plan?.vanity_url || plan?.subscription_id);
                    setSelectedPlan(plan?.subscription_id);
                    setSelectedPlanPrice(plan?.price);
                    setPlanDetails(plan);
                    setSelectedSubscriptionData(plan);
                    setSubscriptions(response?.data?.data);
                } else {
                    console.error("Failed to fetch plan details");
                }
            };

            fetchPlanDetails();
        } else {
            setSelectedPlanDetailsKey(null);
        }
    }, [location.pathname]);

    useEffect(() => {
        if (location?.state?.type === "upgrade") {
            // projectInfo.projectConfig.pubid != 50111 && localStorage.setItem('isUpgrade', 'true');
            localStorage.setItem('previousSubId', location?.state?.subId);
        } else {
            // go on
        }
    }, [])

    useEffect(() => {

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });

        if (!androidToken) {
            fetchSubscriptionList();
            user && setActiveScreen('login-success');
        }

        if (queryParams.get("new-login") === "1") {
            setActiveScreen('login');
        } else {
            //leave it
        }

        localStorage.removeItem("couponId");
        if (!urlParams.get('ref')) {
            setHaveCoupon(false);
        }

    }, [location.pathname]);

    useEffect(() => {

        if (androidToken) {
            const deviceId = urlParams.get("deviceId");
            const info = {
                projectConfig: projectInfo?.projectConfig,
                geoInfo: projectInfo?.geoInfo,
                device_id: deviceId,
            };
            fetchAndroidSubscriptionDetails(androidToken, info);
        } else {
            // do nothing
        }

    }, [androidToken])

    useEffect(() => {
        if (androidLoginSuccess && user) {
            setActiveScreen('login-success');
            fetchSubscriptionList();
            setAndroidLoginSuccess(false);
        }
    }, [androidLoginSuccess, user])

    useEffect(() => {

        if ((videoId || showId || videoVanity || showVanity) && !androidToken) {
            fetchSubscriptionList();
            user && setActiveScreen('login-success');
        } else {
            //leave now
        }

    }, [videoId, showId, videoVanity, showVanity, androidToken])

    useEffect(() => {
        activeLogin && setActiveScreen('login')
        if (activeLogin === false) {
            setActiveScreen('register')
        }
    }, [activeLogin])

    useEffect(() => {
        if (selectedPlan) {
            localStorage.setItem("selectedSubId", selectedPlan);
            localStorage.setItem("deviceType", androidToken || localStorage.getItem('isAndroid') == 'true' ? "android-web" : "web");
            localStorage.setItem("selectedAmount", selectedPlanPrice);
            localStorage.removeItem("couponId");
            if (!urlParams.get('ref')) {
                setHaveCoupon(false);
            }
        } else {
            //keep waiting
        }
        subscriptions.map((item) => {
            if (selectedPlan == item?.subscription_id) {
                setPlanDetails(item);
            }
        })
    }, [selectedPlan])

    useEffect(() => {
        if (password) {
            const mask = '*'?.repeat(password.length);
            setMaskedPassword(mask);
        } else {
            setMaskedPassword();
        }
    }, [password]);

    useEffect(() => {
        if (activeScreen == 'register' || activeScreen == 'login-success') {
            setIsOkToProceed(true)
        } else {
            setIsOkToProceed(false)
        }

        if (!urlParams.get('ref')) {
            setHaveCoupon(false)
        }

    }, [activeScreen])

    useEffect(() => {
        if (!haveCoupon) {
            setError({
                ...error,
                ['coupon']: ''
            });
            setCouponCode();
        } else {
            //do nothing
        }
    }, [haveCoupon])

    useEffect(() => {
        if (showAlreadyExistMessage) {
            setTimeout(() => {
                setShowAlreadyExistMessage(false)
            }, 15 * 1000);
        }
    }, [showAlreadyExistMessage])

    useEffect(() => {
        if (resetPasswordMessage) {
            setTimeout(() => {
                setResetPasswordMessage('')
            }, 5 * 1000);
        }
    }, [resetPasswordMessage])

    useEffect(() => {

        if (userSubscriptionData?.data?.length > 0) {
            const haveValidSubscription = subscriptionCheck();

            if (haveValidSubscription) {
                if (queryParams.get("new-login") === "1") {
                    navigate(-2)
                } else {
                    if (checkoutSubId) {
                        setHasExistingSubscription(true);
                        return;
                    }
                    navigate(-1)
                }
            } else {
                // fail silently
            }
            setHasExistingSubscription(true);
        } else if (userSubscriptionData?.data?.length === 0) {
            setHasExistingSubscription(false);
        } else {
            // fail silently
        }
    }, [userSubscriptionData, showAlreadyExistMessage])

    useEffect(() => {
        if (hasExistingSubscription === true && subscriptions.length === 0) {
            const timeout = setTimeout(() => {
                navigate(redirectUrl || "/");
            }, 4000);
            return () => clearTimeout(timeout);
        }
    }, [hasExistingSubscription, subscriptions, redirectUrl]);

    useEffect(() => {
        if (subscriptionContinue) {
            proceedToPayment();
        }
    }, [subscriptionContinue]);

    useEffect(() => {
        if (gateways) {
            setPaymentGateways({
                cinetPay: gateways.includes('CINETPAY'),
                stripe: gateways.includes('STRIPE'),
                paypal: gateways.includes('PAYPAL'),
                ideabiz: gateways.includes('IDEABIZ'),
                square: gateways.includes('SQUARE'),
                bog: gateways.includes('BOG'),
            });
        } else {
            console.log('WEBSITE_PAYMENT_GATEWAYS not found');
        }
    }, [])

    useEffect(() => {
        if (isFree && projectInfo?.projectConfig?.pubid === 50135 && (selectedPlan === undefined || selectedPlan === null)) {
            setSelectedPlan(-50135);
            setSelectedPlanPrice(0);
            setIsFree(true);
        }
    }, [isFree, projectInfo?.projectConfig?.pubid, selectedPlan]);

    useEffect(() => {
        if (showPaypalContainer) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showPaypalContainer]);

    useEffect(() => {
        window.scroll(0, 0);
        if (location?.state) {
            setLocationState(location?.state)
        }
        if (location?.state?.path) {
            setRedirectUrl(location?.state?.path);
        } else {
            setRedirectUrl("/home");
        }
    }, [location?.state]);

    useEffect(() => {
        if (googleUser) {
            getGoogleUserData();
        }
    }, [googleUser]);

    useEffect(() => {
        setUrlCode(false);
    }, [location.search]);

    useEffect(() => {
        try {
            const ref = new URLSearchParams(location.search || window.location.search).get('ref');
            if (ref && !urlCode && !(couponCode && couponCode.couponCode) && projectInfo?.projectConfig?.pubid !== 50119) {
                setCouponCode({ couponCode: ref.trim() });
                setHaveCoupon(true);
            }
        } catch (e) {
        }
    }, [location.search, couponCode, urlCode]);

    const handleClickOutside = (event) => {
        if (paypalRef.current && !paypalRef.current.contains(event.target)) {
            setShowPaypalContainer(false);
            {
                !subscriptionMethodDiv && setShowContinueButton(true);
            }

        }
    };

    const fetchAndroidSubscriptionDetails = async (androidToken, info) => {

        const data = {
            projectDetails: info,
            accessToken: accessToken,
        };
        const response = await getAndroidSubscriptionDetails(
            data,
            androidToken
        );

        if (response?.status === 200) {

            localStorage.setItem("userId", response?.data?.data[0]?.user_id);
            localStorage.setItem("isAndroid", true);
            localStorage.setItem("deviceType", "android-web");
            localStorage.setItem('selectedLanguageCode', response?.data?.data[0]?.language?.short_code);
            localStorage.setItem('selectedLanguageId', response?.data?.data[0]?.language?.language_id);
            updateLocalStorage(response)
            setUserResponse(response)
            dispatch(
                getLanguageModal({
                    languageModal: {
                        selectedLanguageCode: response?.data?.data[0]?.language?.short_code
                    }
                }))
            const url = new URL(window.location.href);
            const params = new URLSearchParams(url.search);

            // Remove the 'antkn & deviceId' parameters
            params.delete('antkn');
            params.delete('deviceId');

            const newUrl = `${url.pathname}?${params.toString()}`;
            navigate(newUrl, { replace: true });
            setAndroidLoginSuccess(true);
        }
    };


    const fetchSubscriptionList = async () => {
        await fetchUserSubscriptionDetails();
        if (!isVizio) {
            let typeID;
            let typeName;

            if (videoIdAndroid) {
                typeID = videoIdAndroid;
                typeName = 'video';
            } else if (eventIdAndroid) {
                typeID = eventIdAndroid;
                typeName = 'event';
            } else if (channelIdAndroid) {
                typeID = channelIdAndroid;
                typeName = 'channel';
            } else if (videoId) {
                typeID = videoId;
                typeName = 'video';
            } else if (showId) {
                typeID = showId;
                typeName = 'show';
            } else if (videoVanity) {
                typeID = videoVanity;
                typeName = 'video_vanity';
            } else if (showVanity) {
                typeID = showVanity;
                typeName = 'show_vanity';
            } else if (channelId) {
                typeID = channelId;
                typeName = 'channel';
            } else if (location?.state?.type === "upgrade") {
                typeID = location?.state?.subId;
                typeName = null;
            }

            let response;
            if (!checkoutSubId) {
                response = await getVideoSubscription(appInfo, typeID, typeName, 'list', null, location?.state?.is_go_ad_free, location?.state?.is_challenge);
            }

            const subscriptionResponse = await getVideoSubscription(appInfo, typeID, typeName);

            if (subscriptionResponse?.status === 200) {
                setActiveSubscriptions(subscriptionResponse?.data?.data);
            }

            if (response?.status === 200) {
                if (response?.data?.data?.length === 0) {
                    setIsFree(true);
                    setSelectedPlan(0);
                }
                setSubscriptions(response?.data?.data);
                if (subscriptionId) {
                    setSelectedPlan(subscriptionId)
                    setSelectedPlanPrice(subscriptionPrice)
                } else {
                    if (response?.data?.data?.length > 0) {
                        setSelectedPlan(response?.data?.data[0]?.subscription_id)
                        setSelectedPlanPrice(response?.data?.data[0]?.price)
                        setSelectedSubscriptionData(response?.data?.data[0]);
                    } else {
                        setSelectedPlan(0);
                        setSelectedPlanPrice(0);
                    }
                }
                if ([50138, 50135, 50147, 50146, 50111, 50171 , 50167, 50175, 50184, 50182].includes(projectInfo?.projectConfig?.pubid) && !user && !videoId && !showId && !videoVanity && !showVanity && !channelId && !subscriptionId) {
                    setIsFree(true);
                    setSelectedPlan(0);
                }

            }
            setIsLoading(false);
        }
    };

    const fetchUserSubscriptionDetails = async () => {
        const userSubResponse = await getUserSubscription(appInfo);
        if (userSubResponse?.data?.data[0]?.mode_of_payment === 'vizio') {
            setIsVizio(true);
        }
        if (userSubResponse?.status === 200) {
            dispatch(
                getUserSubscriptionData({
                    userSubscription: userSubResponse?.data,
                })
            );
            setUserSubId(userSubResponse?.data?.data[0]?.sub_id);
        }
    };

    const linkHandler = (path) => {
        navigate(path);
    }

    const handleEmailValidation = async () => {

        if (activeScreen !== 'register') {
            return false;
        } else {

            const isEmailValid = await validateEmail(email);
            if (isEmailValid) {
                setError({
                    ['email']: '',
                    ['password']: ''
                });
                // register case: check whether email already exist or not.

                email && isEmailAlreadyRegistered()
            } else {
                setError({
                    ['email']: <Translate textKey={'invalid_email_id'} />,
                    ['password']: ''
                });
            }
        }

    }

    const validateEmail = async (email) => {
        const regex = /^[^@]+@[^@]+\.[^@]+$/;
        return regex.test(email);
    };

    const validatePassword = async (password) => {

        if (password && password != '') {
            return true;
        } else {
            setError({
                ...error,
                ['password']: <Translate textKey={'password_required'} />
            })
            return false;
        }
    }

    const isEmailAlreadyRegistered = async () => {
        const response = await checkIfEmailExists(appInfo, { user_email: email });

        if (response?.status == 201) {
            // toast.error(response?.data?.message)
            setShowAlreadyExistMessage(true);
            setActiveScreen('login')
        } else {
            // console.log(response?.data?.message)
        }
    }

    const handleLoginSubmit = async () => {

        const isEmailValid = await validateEmail(email);
        const isPasswordValid = await validatePassword(password);

        if (isEmailValid && isPasswordValid) {
            setError({})
            const response = await login({ email, password }, appInfo);
            if (response?.status === 200) {
                updateLocalStorage(response)
                setUserResponse(response)
                let hasSub = false;
                if (activeSubscriptions && activeSubscriptions.length > 0) {
                    hasSub = subscriptionCheck();
                } else {
                    setIsFree(true);
                    setSelectedPlan(0);
                }

                if (hasSub) {
                    setHasExistingSubscription(true);
                    setShowAlreadyExistMessage(true);
                    setActiveScreen('login-success');
                    if (redirectUrl && redirectUrl !== "/home") {
                        setTimeout(() => {
                            navigate(redirectUrl);
                        }, 500);
                    }
                } else {
                    setActiveScreen('login-success'); // display user details and info like please select a plan and click on the continue button to proceed the payment.
                    if (redirectUrl && redirectUrl !== "/home" && selectedPlan === 0) {
                        setTimeout(() => {
                            navigate(redirectUrl);
                        }, 500);
                    }
                }
            } else if (response?.status == 201) {
                setUserRegisterId(response?.data?.user_id || response?.data?.userId);
                setCheckoutValues({ email, password });
                setOtpModal(true);
            } else if (response?.status == 202) {
                setResetPasswordMessage(response?.data?.message)
            }
        } else {
            manageErrorMessage(isEmailValid, isPasswordValid);
        }


    }

    const subscriptionCheck = () => {
        const userSub = userSubscriptionData?.data;
        const videoSub = activeSubscriptions;
        return userSub?.some((user) => videoSub?.some((video) => user?.sub_id === video?.subscription_id));
    };

    const handleSubmit = async () => {

    if (isSubmittingRef.current) {
        return;
    }

    isSubmittingRef.current = true;
    setShowContinueButton(false);

    try {
        if (activeScreen == 'register') {
            const isEmailValid = await validateEmail(email);
            const isPasswordValid = await validatePassword(password);

            if (isEmailValid && isPasswordValid) {
                const response = await registerUser(appInfo, { email, password });
                if (response?.status == 200) {
                    setUserResponse(response)
                    updateLocalStorage(response)
                    if (gateways?.length > 1) {
                        setSubscriptionMethodDiv(true);
                        setShowContinueButton(false);
                    } else {
                        proceedToPayment(gateways[0])
                    }
                    // continue the payment flow here
                    // proceedToPayment()
                    if (subscriptions.length === 0) {
                        if (projectInfo?.projectConfig?.pubid === 50135) {
                            setRegistrationMessage(true);
                            setTimeout(() => {
                                navigate(redirectUrl || "/");
                            }, 4000);
                        }
                        else {
                            toast.success(response?.data?.message);
                            navigate(redirectUrl || "/");
                        }
                    } else {
                        if (projectInfo?.projectConfig?.pubid === 50135) {
                            setRegistrationMessage(true);
                            setTimeout(() => {
                                navigate(redirectUrl || "/");
                            }, 4000);
                        }
                        else {
                            proceedToPayment();
                    }
                    }

                } else if (response?.status == 201) {
                    setUserRegisterId(response?.data?.user_id || response?.data?.userId);
                    setCheckoutValues({ email, password });
                    setOtpModal(true);
                }
                else {
                    toast.error(response?.data?.message, {
                        position: "top-center",
                    });
                    isSubmittingRef.current = false;
                    setShowContinueButton(true);
                }

            } else {
                manageErrorMessage(isEmailValid, isPasswordValid);
                isSubmittingRef.current = false;
                setShowContinueButton(true);
            }
        } else {
            if (user) {
                if (selectedPlan == 0) {
                    navigate(-1)
                    return;
                }
                if (gateways?.length > 1) {
                    setSubscriptionMethodDiv(true);
                    setShowContinueButton(false);

                } else {
                    proceedToPayment(gateways[0])
                }
            } else {
                switchToAnotherAccount()
                setResetPasswordMessage('Invalid credentials');
                isSubmittingRef.current = false;
                setShowContinueButton(true);
            }
        }

    } catch (error) {
        console.error("Submit error:", error);
        isSubmittingRef.current = false;
        setShowContinueButton(true);

        toast.error(
            error?.response?.data?.message,
            {
                position: "top-center",
            }
        );
    }
};

    const proceedToPayment = async (selectedMethod) => {
        setShowContinueButton(false);
        if (selectedPlan == 0) { // Free Account scenario
            if (projectInfo?.projectConfig?.pubid === 50135) {
                setRegistrationMessage(true);
                setTimeout(() => {
                    navigate(redirectUrl || "/");
                }, 4000);
            }
            else
                navigate(redirectUrl || "/")
        } else {
            if (couponSuccess) {
                const paymentInfo = {
                    subId: selectedPlan,
                    couponId: couponCode?.couponId,
                };
                try {
                    const stripeResponse = await stripeSession(appInfo, paymentInfo);
                    if (stripeResponse?.status === 200) {
                        window.open(stripeResponse?.data?.url, "_self")

                    }
                    else if (stripeResponse?.info === "PHONE_REQUIRED") {
                        setShowContinueButton(false);
                        setShowPhoneInput(true);
                        setStripeResponse(stripeResponse?.message);
                    }
                } catch (err) {
                    if (err?.response?.data?.info === "PHONE_REQUIRED") {
                        setShowContinueButton(false);
                        setShowPhoneInput(true);
                        setStripeResponse(stripeResponse?.message);
                    }
                    toast.error(err?.response?.data?.message, {
                        position: "bottom-center",
                    });
                }
            } else {
                const paymentInfo = {
                    subId: selectedPlan,
                    couponId: couponCode?.couponId,
                };
                try {
                    switch (selectedMethod) {
                        case "STRIPE":
                        case "stripe":
                            stripeApi(paymentInfo);
                            break;

                        case "PAYPAL":
                        case "paypal":
                            setShowPaypal(true);
                            setShowPaypalContainer(true);
                            break;

                        case "BOG":
                        case "bog":
                            bogPayment();
                            break;

                        case "CINETPAY":
                        case "cinetpay":
                            cinetPayApi();
                            break;

                        case "SQUARE":
                        case "square":
                            squarePayment();
                            break;

                        case "IDEABIZ":
                        case "ideabiz":
                            ideabizHandler();
                            break;

                        default:
                            console.log("Invalid Payment Method Selected");
                    }
                } catch (err) {
                    toast.error(err?.response?.data?.message, {
                        position: "bottom-center",
                    });
                }
            }

        }

    }

    const updateLocalStorage = async (response) => {

        const userDetails = response ? response?.data?.data[0] : userResponse?.data?.data[0];
        if (userDetails?.user_id) {
            localStorage.setItem("userId", userDetails?.user_id);
            localStorage.setItem("selectedSubId", selectedPlan);
            localStorage.setItem("deviceType", androidToken || localStorage.getItem('isAndroid') == 'true' ? "android-web" : "web");
            localStorage.setItem("selectedAmount", selectedPlanPrice);

            tokenAuthenticate();
            updateDeviceAnalytics(
                userDetails?.user_id,
                appInfo,
                userDetails?.user_email
            );
            dispatch(
                getUser({
                    user: userDetails?.user_id,
                })
            );

            dispatch(
                getUserDetails({
                    userDetails
                }));

            await fetchUserSubscriptionDetails();



        } else {
            console.log('user details not found');

        }
    }

    const updateDeviceAnalytics = async (userId, appInfo, userEmail) => {
        await analytics2(userId, appInfo, userEmail);
    };

    const tokenAuthenticate = async () => {
        const response = await authenticate(appInfo);
        if (response?.status === 200) {
            localStorage.setItem('selectedLanguageCode', response?.data?.user_language?.short_code ? response?.data?.user_language?.short_code : response?.user_language?.short_code);
            localStorage.setItem('selectedLanguageId', response?.data?.user_language?.language_id ? response?.data?.user_language?.language_id : response?.user_language?.language_id);
            dispatch(
                getLanguageModal({
                    languageModal: {
                        selectedLanguageCode: response?.data?.user_language?.short_code ? response?.data?.user_language?.short_code : response?.user_language?.short_code
                    }
                }))
            dispatch(
                getAccessToken({
                    accessToken: response?.data?.token ? response?.data?.token : response?.token,
                })
            );
            dispatch(
                getUserDetails({
                    userDetails: response?.data ? response?.data : response,
                })
            );
        }
    };

    const switchToAnotherAccount = () => {
        localStorage.clear();
        setActiveScreen('login');
        setEmail();
        setPassword();
        setMaskedPassword();
        dispatch(
            getUser({
                user: null,
            })
        );
        window.location.href = window.location.href + '?new-login=1';
    }



    const manageErrorMessage = (isEmailValid, isPasswordValid) => {

        const passwordMsg = isPasswordValid ? '' : <Translate textKey={'password_required'} />;
        const emailMsg = isEmailValid ? '' : <Translate textKey={'email_required_message'} />;
        setError({
            password: passwordMsg,
            email: emailMsg
        });
    }

    const applyCouponCodeHandler = () => {

        setCouponProcessing(true);

        if (!couponCode?.couponCode) {
            setCouponProcessing(false);
            setError({
                ...error,
                ['coupon']: <Translate textKey={'enter_coupon_code'} />
            });
        } else {
            couponCodeApi();
        }
    };

    const couponCodeApi = async () => {
        try {
            const couponCodeResponse = await applyCouponCode(
                appInfo,
                couponCode?.couponCode,
                selectedPlan
            );

            if (couponCodeResponse?.status === 200) {
                setCouponProcessing(false);
                setError({
                    ...error,
                    ['coupon']: ''
                })
                setCouponSuccess(true);
                localStorage.setItem("couponId", couponCodeResponse?.data?.data?.coupon_id);

                setCouponCode({
                    ...couponCode,
                    couponId: couponCodeResponse?.data?.data?.coupon_id,
                });

            } else {
                setCouponProcessing(false);
                setError({
                    ...error,
                    ['coupon']: couponCodeResponse?.data?.message
                });
            }
        } catch (err) { }
    };
    const stripeApi = async () => {
        if (couponSuccess) {
            const paymentInfo = {
                subId: selectedSubscriptionData?.subscription_id,
                couponId: couponCode?.couponId,
            };
            try {
                const stripeResponse = await stripeSession(appInfo, paymentInfo);
                if (stripeResponse?.status === 200) {
                    window.open(stripeResponse?.data?.url, "_self")

                }
            } catch (err) {
                if (err?.response?.data?.info === "PHONE_REQUIRED") {
                    setShowContinueButton(false);
                    setShowPhoneInput(true);
                    setStripeResponse(stripeResponse?.message);
                }
                toast.error(err?.response?.data?.message, {
                    position: "bottom-center",
                });
            }
        } else {
            const paymentInfo = {
                subId: selectedSubscriptionData?.subscription_id,
            };
            try {
                const stripeResponse = await stripeSession(appInfo, paymentInfo);

                if (stripeResponse?.status === 200) {
                    window.open(stripeResponse?.data?.url, "_self")
                }

            } catch (err) {
                if (err?.response?.data?.info === "PHONE_REQUIRED") {
                    setShowContinueButton(false);
                    setShowPhoneInput(true);
                    setStripeResponse(stripeResponse?.message);
                }

                toast.error(err?.response?.data?.message, {
                    position: "bottom-center",
                });
            }
        }
    };
    const cinetPayApi = async () => {

        const paymentInfo = {
            subId: selectedSubscriptionData?.subscription_id,
        };
        try {
            const cinetPayApiResponse = await cinetPayApiSession(appInfo, paymentInfo);
            if (cinetPayApiResponse?.status === 200) {
                window.open(cinetPayApiResponse?.data?.data, "_self")
            }
        } catch (err) {
            toast.error(err?.response?.data?.message, {
                position: "bottom-center",
            });
        }

    };

    const squarePayment = async () => {
        const paymentInfo = {
            subId: selectedSubscriptionData?.subscription_id,
        };
        try {
            const squareResponse = await squareSubscription(appInfo, paymentInfo);

            if (squareResponse?.status === 200) {
                window.open(squareResponse?.data?.data?.url, "_self")
            }
        } catch (err) {
            toast.error(err?.response?.data?.message, {
                position: "bottom-center",
            });
        }
    }

    const bogPayment = async () => {
        const paymentInfo = {
            subId: selectedPlan,
        };
        try {

            const bogResponse = await bogSubscription(appInfo, paymentInfo);
            if (bogResponse?.status === 200) {
                toast.success(bogResponse?.data?.message, {
                    position: "bottom-center",
                });
                localStorage.setItem("bogOrderId", bogResponse?.data?.data?.order_id,);
                window.open(bogResponse?.data?.data?.redirect_url, "_self")
            }
        } catch (err) {
            toast.error(err?.response?.data?.message, {
                position: "bottom-center",
            });
        }
    }
    const ideabizHandler = () => {
        localStorage.setItem("selectedAmount", selectedSubscriptionData?.price);
        navigate(`/ideabiz`, {
            state: { subscription: selectedSubscriptionData, appInfo },
        })
    }
    const handleUpcomingInvoice = async (planDetails) => {
        setShowModal(true);
        const invoiceDetails = await getUpcomingInvoice(planDetails, appInfo)
        if (invoiceDetails?.status == 200) {
            const responseData = invoiceDetails?.data
            if (responseData?.success) {
                setShowModal(false);
                setShowConfirmWindow(true)
                const paymentDetails = responseData?.data
                let {
                    amount_due,
                    unused_time,
                    plan_amount,
                    description
                } = paymentDetails
                let details = {
                    due: amount_due,
                    discount: unused_time,
                    plan: plan_amount,
                    description: description
                };
                setInvoiceDetails(details);
                setStripeDeatils(planDetails);
            } else {
                setShowModal(false);
                setShowFailModal(true);
                setInvoiceDetails("No upcoming invoice for this user")
            }
        } else {
            setShowModal(false);
            setShowFailModal(true);
            setInvoiceDetails("No upcoming invoice for this user")
        }
    }

    const handleClick = async (modal, check) => {
        if (modal == "postPayment") {
            if (check == "success") {
                setShowSucessModal(false);
                navigate("/account")
            }
            if (check == "Fail") {
                setShowFailModal(false);
                setShowProcessing(false);
            }
        }
        if (modal == "payment") {
            if (check) {
                setShowConfirmWindow(false);
                setShowModal(true);
                setShowProcessing(true);
                const stripeUpdate = await subscriptionUpdate(stripeDeatils, appInfo)
                if (stripeUpdate?.status == 200) {
                    setShowModal(false);
                    var stripeData = stripeUpdate?.data;
                    if (stripeData?.requires_action) {
                        setShowModal(true)
                        let accessKey = stripeData?.access_key;
                        let clientSecret = stripeData?.client_secret;
                        const stripe = await loadStripe(accessKey);
                        const stripePayment = await stripe.confirmCardPayment(clientSecret);
                        if (stripePayment?.error) {
                            setShowModal(false)
                            navigate("/failed")
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        } else if (stripePayment.paymentIntent && stripePayment.paymentIntent.status === 'succeeded') {
                            let authenticated = true;
                            const stripeUpdate = await subscriptionUpdate(stripeDeatils, appInfo, authenticated)
                            if (stripeUpdate?.status == 200) {
                                setShowModal(false)
                                setShowSucessModal(true);
                            } else {
                                setShowModal(false)
                                navigate("/failed")
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                            }
                        } else {
                            navigate("/failed")
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }
                    } else if (stripeData?.success) {
                        setShowSucessModal(true);
                    } else {
                        navigate("/failed")
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                    }
                } else {
                    setShowModal(false);
                    navigate("/failed")
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }
            } else {
                setShowConfirmWindow(false);
            }
        }
    }

    const onDialCodeChangeHandler = (phone_number) => {
        setChangedValue({
            phone: phone_number,
        });
    }

    const updateHandler = async () => {

        const response = await updateAccountdetails(appInfo, changedValue);

        if (response?.data?.success === true) {
            toast.success(<Translate textKey={'account_updated_message'} />, {
                position: "bottom-center",
            });
            setShowContinueButton(true);
            setSubscriptionContinue(true);
            proceedToPayment("STRIPE");
        }
    }

    const getGoogleUserData = async () => {
        const response = await googleLogin(googleUser?.access_token);
        if (response?.status === 200) {
            const values = {
                googleId: response?.data?.id,
                loginType: "google",
                firstName: response?.data?.name,
                email: response?.data?.email,
            };
            loginWithoutCode(values);
        }
    };

    const googleLoginHandler = useGoogleLogin({
        onSuccess: (codeResponse) => setGoogleUser(codeResponse),
        onError: (error) => { },
    });

    const loginWithoutCode = async (values) => {
        const response = await updateLoginWithoutCode(appInfo, values);
        if (response?.status === 200) {
            localStorage.setItem("userId", response?.data?.data[0]?.user_id);
            if (values?.loginType === "google") {
                window.location.replace(redirectUrl || "/checkout");
                return;
            }
            if (values?.loginType === "apple") {
                if (selectedPlan !== 0) {
                    window.location.replace(redirectUrl || "/home");
                } else {
                    window.location.replace(redirectUrl || "/checkout");
                }
                return;
            }
            tokenAuthenticate();
            updateDeviceAnalytics(
                response?.data?.data[0]?.user_id,
                appInfo,
                response?.data?.data[0]?.user_email,
                response?.data?.data[0]?.first_name
            );
            setTimeout(() => {
                dispatch(
                    getUser({
                        user: response?.data?.data[0]?.user_id,
                    })
                );
            }, 1000);
            navigate(redirectUrl, { state: locationState });
        }
        else if (response?.status === 204) {
            setSocialLoginModalType({
                heading: `Already registered with the same email. Do you want to link your ${values?.loginType} account?`,
                values: values
            });
            setShowSocialLoginModal(true);
        }
    };

    return (
        <>
            {otpModal && (
                <OtpModal
                    setOtpModal={setOtpModal}
                    appInfo={appInfo}
                    userRegisterId={userRegisterId}
                    updateDeviceAnalytics={updateDeviceAnalytics}
                    tokenAuthenticate={tokenAuthenticate}
                    values={checkoutValues}
                    onOtpSuccess={() => {
                        setOtpModal(false);
                        if (activeScreen === 'register') {
                            const selectedGateway = Object.keys(paymentGateways).find(key => paymentGateways[key]);
                            proceedToPayment(selectedGateway);
                        } else {
                            window.location.replace(redirectUrl);
                        }
                    }}
                />
            )}
            {showSocialLoginModal && (
                <SocialAccountLoginModal
                    modalType={socialLoginModalType}
                    setShowSocialLoginModal={setShowSocialLoginModal}
                />
            )}
            {applePrivateLogin &&
                <ApplePrivateLoginModal isEmailForm={true}
                    setApplePrivateLogin={setApplePrivateLogin}
                    setApplePrivateEmail={setApplePrivateEmail} />
            }
            {showConfirmWindow && !showModal ? (
                <>
                    <div className="paymentConfirm ontop"
                        role="dialog"
                        aria-modal="true"
                        aria-label="Payment Confirmation"
                        aria-describedby="payment-confirm-desc"
                        tabIndex={-1}
                    >
                        <div className="paymentConfirmContainer align-center">
                            <div>
                                <h5 id="payment-confirm-desc"><Translate textKey={'payment_confirm'} /></h5>
                                <div class="amount-summary" role="region" aria-label="Amount Summary">
                                    <div class="row">
                                        <span class="label" aria-label="Plan Amount">{invoiceDetails?.description?.plan_amount}</span>
                                        <span class="value" aria-label="Plan">{invoiceDetails?.plan}</span>
                                    </div>
                                    <div class="row">
                                        <span class="label" aria-label="Unused Time">{invoiceDetails?.description?.unused_time}</span>
                                        <span class="value" aria-label="Discount">{invoiceDetails?.discount}</span>
                                    </div>
                                    <hr />
                                    <div class="row">
                                        <span class="label amount-due" aria-label="Amount Due">{invoiceDetails?.description?.amount_due}</span>
                                        <span class="value amount-due" aria-label="Due">{invoiceDetails?.due}</span>
                                    </div>
                                </div>
                                <div className="button-container df" role="group" aria-label="Payment Actions">
                                    <button
                                        onClick={() => {
                                            handleClick("payment", true);
                                        }}
                                        tabIndex={0}
                                        aria-label="Confirm Payment"
                                        onKeyDown={e => {
                                            if (e.key === 'Enter' || e.key === ' ') handleClick("payment", true);
                                        }}
                                    >
                                        <Translate textKey={'ok'} />
                                    </button>
                                    <button
                                        onClick={() => {
                                            handleClick("payment", false);
                                        }}
                                        tabIndex={0}
                                        aria-label="Cancel Payment"
                                        onKeyDown={e => {
                                            if (e.key === 'Enter' || e.key === ' ') handleClick("payment", false);
                                        }}
                                    >
                                        <Translate textKey={'cancel'} />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : null}
            {showSucessModal ? (<div
                className="success ontop"
                role="alertdialog"
                aria-label="Payment Success"
                aria-describedby="payment-success-desc"
                tabIndex={-1}
            >
                <div className="successContainer align-center">
                    <div className="checkIcon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="92"
                            height="92"
                            fill="#fff"
                            className="bi bi-check2"
                            viewBox="0 0 16 16"
                            aria-hidden="true"
                        >
                            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" />
                        </svg>
                    </div>
                    <h5 id="payment-success-desc"><Translate textKey={'success'} /></h5>
                    <p><Translate textKey={'payment_success_message'} /></p>
                    <button
                        tabIndex={0}
                        aria-label="OK"
                        onKeyDown={e => {
                            if (e.key === 'Enter' || e.key === ' ') handleClick("postPayment", "success");
                        }}
                        onClick={() => handleClick("postPayment", "success")}><Translate textKey={'ok'} />
                    </button>
                </div>
            </div>) : null}
            {showModal ? (<div className="paymentConfirm ontop">
                <div className="paymentConfirmContainer align-center min-ht">
                    {!showProcessing ? <p className="checking"><Translate textKey={'loading'} /></p> : <p className="checking"><Translate textKey={'payment_processing'} /></p>}

                </div>
            </div>) : null}
            {showFailModal ? (<div className="paymentConfirm ontop" role="alertdialog" aria-label="Payment Failed">
                <div className="paymentConfirmContainer align-center min-ht">
                    <div>
                        <p className="checking">{invoiceDetails}</p>
                        <div className="button-container df" >
                            <button onClick={() => handleClick("postPayment", "Fail")}
                                tabIndex={0}
                                aria-label="OK"
                                onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') handleClick("postPayment", "Fail"); }}
                            > <Translate textKey={'ok'} /></button>
                        </div>
                    </div>
                </div>
            </div>) : null}
            <div className={`checkout-page ${isRTL ? "rtl" : ""} ${theme === 'LIGHT' ? 'light-theme' : ''}`} role="main" aria-label="Checkout Page">
                <style>
                    {`
                    .dynamic-styles {
                        background: ${projectInfo?.projectConfig?.config.BUTTON_COLOR};
                        color:${projectInfo?.projectConfig?.config.TEXT_COLOR};
                    }
                `}
                </style>
                <div className="wrapper">
                    {
                        emailLoginModal &&
                        <LoginModal isEmailForm={true} setEmailLoginModal={setEmailLoginModal} tvCode={tvCode} />
                    }
                    <div className="left" role="region" aria-label="Account Section">
                        <div>
                            <span className={`heading  ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
                                {activeScreen == 'register' ? <Translate textKey={'create_your_account'} /> : activeScreen == 'login-success' ? <Translate textKey={'account_confirmation'} /> : <Translate textKey={'access_your_account'} />}
                            </span>
                            {activeScreen != 'login-success' && <div className="sign-in-link-section">
                                {activeScreen == 'register' ? <>
                                    <span className={`sub-heading ${theme === 'LIGHT' ? 'light-theme' : ''}`}><Translate textKey={'register_sign_in_text'} /></span>

                                    <span
                                        className={`signin-link 
                                ${(template === 'TEMPLATE_9' || template === 'TEMPLATE_12') ? 'template-9-color' : ''} 
                                ${theme === 'LIGHT' ? 'light-theme' : ''}`}
                                        onClick={() => setActiveScreen('login')}
                                    >
                                        <Translate textKey={'sign_in'} />
                                    </span>


                                </>
                                    : <>
                                        <span className={`sub-heading ${theme === 'LIGHT' ? 'light-theme' : ''}`}><Translate textKey={'create_new_account'} /></span>
                                        <span className={`signin-link ${(template === 'TEMPLATE_9' || template === 'TEMPLATE_12') ? 'template-9-color' : ''} ${theme === 'LIGHT' ? 'light-theme' : ''}`} onClick={() => setActiveScreen('register')}><Translate textKey={'register'} /></span>
                                    </>}
                            </div>}

                        </div>
                        {projectInfo?.projectConfig?.config?.SOCIAL_LOGIN_REQUIRED ===
                            "true" && activeScreen != 'login-success' ? <div className="user-section">
                            {projectInfo?.projectConfig?.config?.APPLE_LOGIN_REQUIRED === "true" && projectInfo?.projectConfig?.config?.APPLE_CLIENT_ID &&
                                <div className="apple_login" id="appleid-signin" data-color="black" data-border="true" data-type="sign in" style={{ padding: '0px', marginBottom: '8px' }}></div>
                            }

                            {projectInfo?.projectConfig?.config?.GOOGLE_LOGIN_REQUIRED === "true" &&
                                projectInfo?.projectConfig?.config?.GOOGLE_CLIENT_ID && (
                                    <div
                                        className="login-with-google-wrapper"
                                        onClick={() => googleLoginHandler()}
                                    >
                                        <button>
                                            <GoogleIcon />
                                            <span><Translate textKey={'google_sign_in'} /></span>
                                        </button>
                                    </div>
                                )}

                            {projectInfo?.projectConfig?.config?.LOGIN_WITH_MAGIC_LINK_REQUIRED === "true" && activeScreen == 'login' &&
                                <> <div className="login-with-email-wrapper"
                                    onClick={() => {
                                        localStorage.setItem('redirectFromNewCheckoutPage', 'true')
                                        setEmailLoginModal(true);
                                    }}
                                >
                                    <button className={`dynamic-styles ${(template === 'TEMPLATE_9' || template === 'TEMPLATE_12') ? 'template-9-color' : ''} ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
                                        <Translate textKey={'sign_in_via_email'} />
                                    </button>
                                </div>

                                    <div className="seperate"><div className={`line ${theme === 'LIGHT' ? 'light-theme' : ''}`}></div><span className={`devider ${theme === 'LIGHT' ? 'light-theme' : ''}`}><Translate textKey={'or'} /></span><div className={`line ${theme === 'LIGHT' ? 'light-theme' : ''}`}></div></div>
                                    <div className="login-with-email-password">
                                        <span><Translate textKey={'sign_in_via_email_password'} /></span>
                                    </div>
                                </>
                            }
                            <div>
                                <input type="email" placeholder={translateText("email")}
                                    onChange={(event) => {
                                        setEmail(event?.target?.value);
                                    }}

                                    onFocus={() => { setError({ ...error, ['email']: '' }) }}


                                />

                                {showAlreadyExistMessage && <div className="existing-user-message"><span className="close-message"
                                    onClick={() => { setShowAlreadyExistMessage(false) }}>x</span><p><Translate textKey={'existing_user_message'} /></p></div>}

                                {error?.email && <span className="error">{error.email}</span>}
                            </div>
                            <div className="password-section">
                                {isFocused || showPassword ? <>{password && <span className={`password-show ${(template === 'TEMPLATE_9' || template === 'TEMPLATE_12') ? 'template-9-color' : ''}`}
                                    onClick={() => { setShowPassword(false) }}
                                ><svg width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M2 2L22 22" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M6.71277 6.7226C3.66479 8.79527 2 12 2 12C2 12 5.63636 19 12 19C14.0503 19 15.8174 18.2734 17.2711 17.2884M11 5.05822C11.3254 5.02013 11.6588 5 12 5C18.3636 5 22 12 22 12C22 12 21.3082 13.3317 20 14.8335" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M14 14.2362C13.4692 14.7112 12.7684 15.0001 12 15.0001C10.3431 15.0001 9 13.657 9 12.0001C9 11.1764 9.33193 10.4303 9.86932 9.88818" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> </g></svg></span>
                                }</> : <>{password && <span className="password-show"
                                    onClick={() => { setShowPassword(true) }}
                                ><svg width={20} height={20} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M1 12C1 12 5 4 12 4C19 4 23 12 23 12" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M1 12C1 12 5 20 12 20C19 20 23 12 23 12" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <circle cx="12" cy="12" r="3" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></circle> </g></svg></span>}</>}

                                <input type='text'
                                    placeholder={translateText(activeScreen == 'register' ? "create_password" : 'password')}
                                    onFocus={() => {
                                        handleEmailValidation();
                                        setIsFocused(true); // Mark as focused to show the actual password while editing
                                    }}
                                    value={isFocused || showPassword ? password : maskedPassword}
                                    onChange={(event) => {
                                        setPassword(event?.target?.value);
                                    }}
                                    onBlur={() => setIsFocused(false)}
                                />
                                {error?.password && <span className="error">{error.password}</span>}
                                {resetPasswordMessage && activeScreen == 'login' &&
                                    <div>
                                        <p className="login-success-message error">{resetPasswordMessage}</p>
                                    </div>}

                                {!resetPasswordMessage && activeScreen == 'login' && projectInfo?.projectConfig?.config?.CUSTOM_LOGIN_SCREEN_MESSAGE &&
                                    <div>
                                        <p className="login-success-message error">{projectInfo?.projectConfig?.config?.CUSTOM_LOGIN_SCREEN_MESSAGE}</p>
                                    </div>}


                            </div>
                            {activeScreen == 'login' && <div className="forgot-link">
                                <Link to="/forgot-password">
                                    <div className={`sub-heading link forgot-text ${(template === 'TEMPLATE_9' || template === 'TEMPLATE_12') ? 'template-9-color' : ''} ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
                                        <Translate textKey="forgot_password" />
                                    </div>


                                </Link>

                                <button
                                    className={`login-button dynamic-styles ${(template === 'TEMPLATE_9' || template === 'TEMPLATE_12') ? 'template-9-color' : ''} ${theme === 'LIGHT' ? 'light-theme' : ''}`}
                                    onClick={() => handleLoginSubmit()}
                                >
                                    <Translate textKey={'sign_in'} />
                                </button>


                            </div>}
                        </div> : <div className="user-section">

                            {userData && (
                                <p className={`login-success-message ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
                                    <Translate textKey={'logged_as'} />{" "}
                                    <span className={`link ${(template === 'TEMPLATE_9' || template === 'TEMPLATE_12') ? 'template-9-color' : ''} ${theme === 'LIGHT' ? 'light-theme' : ''}`}>

                                        {userData?.user_email}
                                    </span>. <Translate textKey={'select_plan_message'} />
                                </p>
                            )}

                            <>
                                <span className="sub-heading"><Translate textKey={'switch_account'} /></span>
                                <span className={`link ${(template === 'TEMPLATE_9' || template === 'TEMPLATE_12') ? 'template-9-color' : ''}`} onClick={() => { switchToAnotherAccount() }}><Translate textKey={'sign_in'} /></span>
                            </>
                        </div>}

                        {activeScreen != 'login' && <div className="coupon-wrapper">
                            <div className="coupon-link" >
                                <input
                                    type="checkbox"
                                    className="coupon-check"
                                    checked={haveCoupon}
                                    onChange={() => { setUrlCode(true); setHaveCoupon(prev => !prev); }}
                                />
                                <div className={`sub-heading link forgot-text coupon-text 
                                    ${(template === 'TEMPLATE_9' || template === 'TEMPLATE_12') ? 'template-9-color' : ''} 
                                    ${theme === 'LIGHT' ? 'light-theme' : ''}`}
                                    onClick={() => { setUrlCode(true); setHaveCoupon(prev => !prev); }}
                                >
                                    <Translate textKey={'having_coupon'} />
                                </div>

                            </div>
                            {
                                haveCoupon &&
                                <div className="coupon-section">
                                    <input
                                        type='text'
                                        placeholder={translateText("enter_coupon_code")}
                                        value={couponCode?.couponCode || ''}
                                        onFocus={() => {
                                            setUrlCode(true);
                                            setError({
                                                ...error,
                                                ['coupon']: ''
                                            })
                                        }}
                                        onChange={(event) => {
                                            setUrlCode(true);
                                            setCouponCode({
                                                ...couponCode,
                                                ['couponCode']: event?.target?.value
                                            })
                                        }} />
                                    <button className={`dynamic-styles ${(template === 'TEMPLATE_9' || template === 'TEMPLATE_12') ? 'template-9-color' : ''} ${theme === 'LIGHT' ? 'light-theme' : ''}`} onClick={() => { !couponProcessing && applyCouponCodeHandler(); }} >
                                        {couponProcessing ? <Translate textKey={'processing'} /> : <Translate textKey={'apply'} />}
                                    </button>
                                </div>
                            }
                            {error?.coupon && <span className="error">{error.coupon}</span>}
                            {couponSuccess && <span className="success">{<Translate textKey={"coupon_success_message"} />}</span>}
                        </div>}
                    </div>
                    <div className={`right ${theme === 'LIGHT' ? 'light' : ''}`} role="region" aria-label="Plan Selection Section">
                        {isVizio ? (
                            <div className={`vizio-message ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
                                <Translate textKey={'vizio_subscription_message'} /><span onClick={() => window.open('https://www.vizio.com/en/vizio-account', '_blank')} className={`link ${(template === 'TEMPLATE_9' || template === 'TEMPLATE_12') ? 'template-9-color' : ''} ${theme === 'LIGHT' ? 'light-theme' : ''}`}>https://www.vizio.com/en/vizio-account</span>.
                            </div>
                        ) : (
                            <>
                                {!selectedPlanDetailsKey &&
                                    <div>
                                        <span className={`heading  ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
                                            <Translate textKey={'select_package'} />
                                        </span>
                                    </div>
                                }
                                <div className="package-section">

                                    {selectedPlanDetailsKey ? (
                                        <PlanDetails planKey={selectedPlanDetailsKey} onBack={handleBackFromPlanDetails} flag={true} planSelected={planSelected} />
                                    ) :
                                        isLoading ?
                                            <div className={`package-item  ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
                                                <div className="heading-section">
                                                    <div className="heading-wrapper">
                                                        <span className="sub-heading"><Translate textKey={'subscription_fetch'} /></span>
                                                    </div>
                                                </div>
                                            </div>
                                            : (
                                                subscriptions.length > 0 ? subscriptions.map((item, index) => {
                                                    return <div className={`package-item  ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
                                                        <div className="heading-section">
                                                            <div className="heading-wrapper"
                                                                onClick={() => { setSelectedPlan(item?.subscription_id); setSelectedPlanPrice(item?.price); setSelectedSubscriptionData(item); }}
                                                            // onClick={() => { handlePlanClick(item) }}
                                                            >
                                                                <span className={`heading  ${theme === 'LIGHT' ? 'light-theme' : ''}`}>{item?.subscription_name}</span>
                                                                <span className={`sub-heading  ${theme === 'LIGHT' ? 'light-theme' : ''}`}>{item?.subscription_text}</span>
                                                            </div>
                                                            <div className="plan-options-wrapper">
                                                                <input type="radio" id={`selected-plan-${index}`} name="selected-plan" checked={selectedPlan == item?.subscription_id ? true : false} onChange={() => { setSelectedPlan(item?.subscription_id); setSelectedPlanPrice(item?.price); setSelectedSubscriptionData(item); }} className="selected-plan plan-options" />
                                                            </div>
                                                        </div>
                                                        {activeDetailsPlan == item?.subscription_id && <div className={`plan-description${theme === 'LIGHT' ? 'light-theme' : ''}`}>{stripHtml(item?.description)}</div>}
                                                        <div className={`details ${(template === 'TEMPLATE_9' || template === 'TEMPLATE_12') ? 'template-9-color' : ''} `} onClick={() => { activeDetailsPlan ? setActiveDetailsPlan() : setActiveDetailsPlan(item?.subscription_id) }}>
                                                            {activeDetailsPlan == item?.subscription_id ? <Translate textKey={'see_less'} /> : <Translate textKey={'see_details'} />}
                                                        </div>
                                                    </div>
                                                }) : hasExistingSubscription && (
                                                    <div className={`package-item  ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
                                                        <div className="heading-section">
                                                            <div className="heading-wrapper">
                                                                <span className="sub-heading"><Translate textKey={'subscription_exists_message'} /></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            )}

                                    {isFree && (
                                        projectInfo?.projectConfig?.pubid === 50135 ? (
                                            <div className={`package-item ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
                                                <div className="heading-section">
                                                    <div className="heading-wrapper">
                                                        <span className={`heading ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
                                                            <Translate textKey={'membership'} />
                                                        </span>
                                                        <span className={`sub-heading ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
                                                            <Translate textKey={'free'} /> $0
                                                        </span>
                                                    </div>
                                                    <div className="plan-options-wrapper">
                                                        <input type="radio" id={`selected-plan-free`} name="selected-plan" checked={subscriptions.length === 0 || selectedPlan === 0} onChange={() => { setSelectedPlan(0); setSelectedPlanPrice(0); }} className="selected-plan plan-options" />
                                                    </div>
                                                </div>

                                                {showMembershipDetails && (
                                                    <div className={`plan-description ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
                                                        <Translate textKey={'membership_register_msg'} />
                                                    </div>
                                                )}

                                                <div
                                                    className={`details ${(template === 'TEMPLATE_9' || template === 'TEMPLATE_12') ? 'template-9-color' : ''}`}
                                                    onClick={() => setShowMembershipDetails((prev) => !prev)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    {showMembershipDetails ? (
                                                        <span><Translate textKey={'see_less'} /></span>
                                                    ) : (
                                                        <span><Translate textKey={'see_details'} /></span>
                                                    )}
                                                </div>
                                            </div>
                                        ) : (
                                            <div className={`package-item ${theme === 'LIGHT' ? 'light-theme' : ''}`}>
                                                <div className="heading-section">
                                                    <div className="heading-wrapper">
                                                        <span className="heading">
                                                            <Translate textKey={'free_account'} />
                                                        </span>
                                                        <span className="sub-heading">
                                                            <Translate textKey={'watch_for_free'} />
                                                        </span>
                                                    </div>
                                                    <div className="plan-options-wrapper">
                                                        <input type="radio" id={`selected-plan-free`} name="selected-plan" checked={subscriptions.length === 0 || selectedPlan === 0} onChange={() => { setSelectedPlan(0); setSelectedPlanPrice(0); }}
                                                            className="selected-plan plan-options"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    )}



                                    {projectInfo.projectConfig.pubid != 50147 &&
                                        <div>
                                            <p className={`disclaimer-text ${theme === 'LIGHT' ? 'theme-light' : ''}`}>
                                                <Translate textKey={'disclaimer-text'} /> {projectInfo.projectConfig.config.TAB_TITLE}'s &nbsp;
                                                <span className={`link   ${(template === 'TEMPLATE_9' || template === 'TEMPLATE_12') ? 'template-9-color' : ''}`} onClick={() => { linkHandler('/terms-and-conditions') }}><Translate textKey={'terms_of_use'} /></span> <Translate textKey={'and'} /> &nbsp;
                                                <span className={`link  ${(template === 'TEMPLATE_9' || template === 'TEMPLATE_12') ? 'template-9-color' : ''}`} onClick={() => { linkHandler('/privacy-policy') }}><Translate textKey={'privacy_policy'} /></span> <Translate textKey={'disclaimer-text_two'} /> &nbsp;
                                                {projectInfo.projectConfig.config.TAB_TITLE} <Translate textKey={'disclaimer-text_three'} />
                                            </p>
                                        </div>
                                    }
                                    {showContinueButton && (
                                        <div className="continue-buttonContainer">
                                            {planSubId && userSubId && planSubId === userSubId ? (
                                                <div className="subscription-exists-message">
                                                    <h2> <Translate textKey="subscription_already_exists" /></h2>
                                                </div>
                                            ) : (
                                                isOkToProceed && !couponProcessing && (
                                                    <button className={`continue-button dynamic-styles ${(template === 'TEMPLATE_9' || template === 'TEMPLATE_12') ? 'template-9-color' : ''}`}
                                                        disabled={subscriptionContinue  && !showContinueButton}
                                                        onClick={() => {
                                                            if (hasExistingSubscription && subscriptions.length === 0) {
                                                                navigate(redirectUrl || "/");
                                                            } else if (location?.state?.type === "upgrade") {
                                                                handleUpcomingInvoice(planDetails);
                                                            } else {
                                                                handleSubmit();
                                                            }
                                                        }}>
                                                        {location?.state?.type === "upgrade" ? (
                                                            <Translate textKey="update" />
                                                        ) : subscriptionContinue ? (
                                                            <Translate textKey="processing" />
                                                        ) : (
                                                            <Translate textKey="continue" />
                                                        )}
                                                    </button>
                                                )
                                            )}
                                        </div>
                                    )}
                                    {registrationMessage && (
                                        <div className="registration-message-overlay">
                                            <div className="registration-message Registersuccess">
                                                <div className="regMessageContainer">
                                                    <p className="Registermessage-one"><Translate textKey={'register_successmsg_one'} /></p>
                                                    <p className="Registermessage-two"> <Translate textKey={'register_successmsg_two'} /></p>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                </div>
                                {subscriptionMethodDiv && (
                                    <div className="subscription-listing" ref={subscriptionListingRef}>
                                        <div className="subscription-heading">
                                            <h2><Translate textKey={'choose_payment'} /></h2>
                                        </div>
                                        <div className="payment-gateways">
                                            {gateways.map((gateway, index) => (
                                                <div key={index} className="gateway-item">
                                                    {gateway === "BOG" && paymentGateways.bog && (
                                                        <div className="payment-method">
                                                            <ul className="gateways">
                                                                <li onClick={() => proceedToPayment("BOG")} title={gateway}>
                                                                    <div className="imageContainer">
                                                                        <img src={require("../../../assets/Images/bog_new.jpg")} alt="BOG" />
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    )}

                                                    {gateway === "PAYPAL" && paymentGateways.paypal && (
                                                        <div className="payment-method">
                                                            <ul className="gateways">
                                                                <li onClick={() => proceedToPayment("PAYPAL")} title={gateway}>
                                                                    <div className="paypalImageContainer">
                                                                        <img src={require("../../../assets/Images/paypal.png")} alt="Paypal" />
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    )}

                                                    {gateway === "STRIPE" && paymentGateways.stripe && (
                                                        <div className="payment-method">
                                                            <ul className="gateways">
                                                                <li onClick={() => proceedToPayment("STRIPE")} title={gateway}>
                                                                    <div className="imageContainer">
                                                                        <img src={require("../../../assets/Images/stripe.png")} alt="Stripe" />
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    )}

                                                    {gateway === "CINETPAY" && paymentGateways.cinetPay && (
                                                        <div className="payment-method">
                                                            <ul className="gateways">
                                                                <li onClick={() => proceedToPayment("CINETPAY")} title={gateway}>
                                                                    <div className="imageContainer">
                                                                        <img src={require("../../../assets/Images/cinetpay.png")} alt="Cinet Pay" />
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    )}

                                                    {gateway === "SQUARE" && paymentGateways.square && (
                                                        <div className="payment-method">
                                                            <ul className="gateways">
                                                                <li onClick={() => proceedToPayment("SQUARE")} title={gateway}>
                                                                    <div className="imageContainer">
                                                                        <img src={require("../../../assets/Images/square.png")} alt="Square" />
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    )}

                                                    {gateway === "IDEABIZ" && paymentGateways.ideabiz && (
                                                        <div className="payment-method">
                                                            <ul className="gateways">
                                                                <li onClick={() => proceedToPayment("IDEABIZ")} title={gateway}>
                                                                    <div className="imageContainer">
                                                                        <img src={require("../../../assets/Images/ideabiz1.png")} alt="Ideabiz" />
                                                                    </div>
                                                                </li>
                                                            </ul>
                                                        </div>
                                                    )}
                                                </div>
                                            ))}
                                        </div>


                                    </div>
                                )}
                                {showPaypalContainer && showPaypal && (
                                    <div className="paypal-container" ref={paypalRef}>
                                        <PayPalScriptProvider
                                            options={{
                                                "client-id": projectInfo?.projectConfig?.config?.PAYPAL_CLIENT_ID,
                                                components: "buttons",
                                                currency: selectedSubscriptionData?.currency,
                                                vault: true,
                                                intent: selectedSubscriptionData?.subscription_type_id === 3 ||
                                                    selectedSubscriptionData?.subscription_type_id === 4
                                                    ? "subscription"
                                                    : "capture",
                                            }}
                                        >
                                            <PaypalButtonWrapper subscriptionData={selectedSubscriptionData} />
                                        </PayPalScriptProvider>
                                    </div>
                                )}

                                {showPhoneInput && (
                                    <div className="phoneNumber-container">
                                        <div className="phone-input-container">

                                            <PhoneInput
                                                country={'us'}
                                                enableSearch={true}
                                                dropdownStyle={{
                                                    height: '120px',
                                                    textAlign: 'justify',
                                                    background: '#cccccc17 !important',
                                                    color: 'rgb(111, 113, 115)',
                                                    height: '100px',
                                                    overflowY: 'scroll',
                                                    scrollbarWidth: 'none',
                                                    msOverflowStyle: 'none',
                                                    width: '382px',
                                                    top: '90%',

                                                }}
                                                inputStyle={{
                                                    border: 'none',
                                                    width: '100%',
                                                    color: 'rgb(111, 113, 115)',
                                                    height: '50px',
                                                    background: '#cccccc17 ',
                                                    cursor: 'pointer !important',
                                                }}
                                                containerClass="custom-phone-input"
                                                dropdownClass="custom-dropdown"
                                                placeholder="Phone Number"
                                                name="phone"
                                                onChange={onDialCodeChangeHandler}
                                            />
                                            {<p>{stripeResponse?.message}</p>}
                                        </div>

                                        <div className="update-button-Container">
                                            <button className={`update-button dynamic-styles ${(template === 'TEMPLATE_9' || template === 'TEMPLATE_12') ? 'template-9-color' : ''}`}
                                                onClick={async () => {
                                                    if (changedValue && changedValue.phone && changedValue.phone.trim() !== "") {
                                                        //here i want to check whether the number prefix is having + sign or not if there is no + sign then i want to add + sign at the starting
                                                        if (!changedValue.phone.startsWith('+')) {
                                                            changedValue.phone = '+' + changedValue.phone;
                                                        }
                                                        await updateHandler(changedValue);
                                                        setShowPhoneInput(false);
                                                    } else {
                                                        toast.error(<Translate textKey={'enter_valid_phone_number'} />, {
                                                            position: "bottom-center",
                                                        });
                                                    }
                                                }}>
                                                <Translate textKey={'update'} />
                                            </button>
                                        </div>

                                    </div>

                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </>

    )
}

export default Checkout;
